module.exports = __webpack_public_path__ + "static/media/upload-products.09548b05.svg";